export default __webpack_public_path__ + "4468a37fe75b7ca8397bb56e138fd436.svg";